<template>
   <v-row align="center" class="my-16 rounded" style="background-color: #00B1C3; min-width: 400px">
        <v-col>
            <v-card elevation="2">
                <v-card-text>
                    <v-row
                        class="my-4"
                        align="center"
                        justify="center"
                    >
                        <h2>Health Clinic</h2>
                    </v-row>
                    <v-row
                        align="center"
                        justify="center"
                        class="mb-6"
                    >
                        <v-spacer></v-spacer>

                        <v-col
                            cols="8"
                            md="4"
                            align="center"
                        >
                            <p>At Prospira we not only care about the health of
                                our teammates, we prioritize it. That's why we
                                have an on-site health clinic that is readily
                                available for all of our teammates.
                            </p>

                            <p>We have health care professionals on site with
                                coverage spanning multiple shifts to ensure
                                the well-being of our teammates.
                            </p>
                        </v-col>

                        <v-spacer></v-spacer>

                        <v-col
                            cols="8"
                            md="4"
                            align="center"
                        >
                            <v-card flat>
                                <v-img
                                    src="@/assets/Well_at_Work.png"
                                    aspect-ratio="1.12"
                                    width="300"
                                    alt="Blanchard Valley Health System well at work occupational health logo"
                                ></v-img>
                            </v-card>
                        </v-col>

                        <v-spacer></v-spacer>
                    </v-row>
                </v-card-text>
                
            </v-card>
        </v-col>

        <v-col cols="12" md="2" align="center">
            <div>
                <h2 style="color: white;">HEALTH CLINIC</h2>
            </div>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'HealthClinicCard'
}
</script>